
export const textResponseStyle = theme => ({
    contentInitalTextSearch: {
        textAlign: 'center'
    }
})